import React, { useState } from "react";
import Sidebar from "../Components/SideBar";
import { useAuth } from "react-oidc-context";
import Onboarding from "./Onboarding";


function wrapContent(auth, content) {
  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in...</div>;
    case "signoutRedirect":
      return <div>Signing you out...</div>;
  }

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return <React.Fragment>{content()}</React.Fragment>;
  }
  auth.signinRedirect();
}

function content() {
  return (       
          <Onboarding />
  );
}

function OnboardingDashboard() {
  const auth = useAuth();

  return <div className="parentDiv">{wrapContent(auth, content)}</div>;
}

export default OnboardingDashboard;
